import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { Observable, switchMap } from "rxjs";
import { FormGroup } from "@angular/forms";
import {
  DataService,
  CustomDetailComponent,
  SharedModule,
  NotificationService,
} from "@bb-vendure/admin-ui/core";
import { AssetFileInputComponent } from "../asset-file-input/asset-file-input.component";
import { UploadApkDocument } from "src/generated-gql/graphql";
import { take } from "rxjs";

@Component({
  standalone: true,
  imports: [SharedModule, AssetFileInputComponent],
  templateUrl: "./single-asset-picker.component.html",
  styleUrl: "./single-asset-picker.component.scss",
})
export class SingleAssetPickerComponent
  implements CustomDetailComponent, OnInit
{
  entity$: Observable<any>;
  detailForm: FormGroup;

  extraInfo$: Observable<any>;

  uploading = false;

  selectedFile:
    | {
        needCreatedAssetFile: any;
        information:
          | {
              name: string;
              link: string | null | undefined;
              createdAt: any;
            }
          | null
          | undefined;
      }
    | null
    | undefined;

  changes: boolean;

  saving = false;

  constructor(
    private dataService: DataService,
    private notificationService: NotificationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.entity$.subscribe((res) => {
      if (res) {
        const existedApk = res.customFields.applicationApk;

        if (existedApk) {
          this.selectedFile = {
            needCreatedAssetFile: null,
            information: {
              name: existedApk.name,
              link: existedApk.source,
              createdAt: existedApk.createdAt,
            },
          };
        }
      }
    });
  }

  createAssets(files: File[]) {
    if (files.length > 0) {
      const file = files[0];

      this.selectedFile = {
        needCreatedAssetFile: files[0],
        information: {
          name: file.name,
          link: null,
          createdAt: null,
        },
      };

      //this.selectedFile = files[0];
      this.changes = true;
    }
  }

  save() {
    // Check for remove
    if (
      !this.selectedFile ||
      (this.selectedFile && !this.selectedFile.needCreatedAssetFile)
    ) {
      return;
    }
    this.changes = false;
    this.saving = true;

    this.dataService
      .mutate(UploadApkDocument, {
        input: {
          file: this.selectedFile.needCreatedAssetFile,
          tags: ["APK"],
        },
      })
      .pipe(take(1))
      .subscribe((res) => {
        if (res.uploadApplicationApk) {
          this.selectedFile = {
            needCreatedAssetFile: null,
            information: {
              name: res.uploadApplicationApk.name,
              link: res.uploadApplicationApk.source,
              createdAt: res.uploadApplicationApk.createdAt,
            },
          };
          this.notificationService.success("common.notify-saved-changes");
          this.saving = false;
          this.cdr.markForCheck();
        }
      });
  }

  remove() {
    this.selectedFile = null;
    this.changes = true;
  }
}
